<template>
  <section>
    <Toast />
    <div class="w-full">
      <Dialog :closable="false" v-model:visible="displayModal" modal header="Adjuntar soportes" :style="{ width: '40vw' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
        <div class="w-full mb-4">
          <label for="documento" class="text-xs text-gray-600 italic">Nombre del documento</label>
          <InputText type="text" class="w-full" v-model="soporte.nombre" />
        </div>
        <div>
          <div class="" v-if="soporte.nombre_adjunto">
            <div class="bg-blue-300 flex justify-between rounded-md p-2 text-blue-600 font-bold text-sm border border-r-2">
              <div class="flex gap-2">
                <p>{{ soporte.nombre_adjunto }}</p>
              </div>
              <button @click="eliminarArchivo">
                <i class="pi pi-times text-sm"></i>
              </button>
            </div>
          </div>
          <FileUpload
            v-else
            mode="basic"
            class="w-full bg-white text-blue-600"
            name="demo[]"
            url="./upload.php"
            accept=".pdf"
            :maxFileSize="1000000"
            chooseLabel="Adjuntar"
            @change="leerArchivo()"
            ref="file"
            id="documento"
          />
        </div>
        <template #footer>
          <Button  label="Cancelar" severity="secondary" icon="pi pi-times" />
          <Button @click="guardarArchivo" label="Guardar" icon="pi pi-save" />
        </template>
      </Dialog>
      <div class="w-full mt-4" v-if="contratosStore._soportes.length">
        <DataTable class="p-datatable-sm text-sm" showGridlines :value="contratosStore._soportes" tableStyle="min-width: 50rem">
          <Column field="nombre" header="Nombre" class="w-full"></Column>
          <Column field="nombre_adjunto" header="Descargar">
            <template #body="slotProps">
              <Button size="small" @click="descargarPdf(slotProps.data.url)" icon="pi pi-download" aria-label="Descargar" />
            </template>
          </Column>
          <!-- <Column header="Fecha de carga del archivo"></Column> -->
          <Column field="" class="w-4 " header="Eliminar">
            <template #body="slotProps">
              <div class="text-center">
                <button @click="eliminar(slotProps.data)"><i class="pi pi-trash text-red-600"></i></button>
              </div>
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </section>
</template>
<script>
  import { ref } from 'vue'
  import { useToast } from 'primevue/usetoast'
  import { useContratosStore } from '../../../stores/contratos.store'
  import { useRoute } from 'vue-router'
  import { helper } from '@/utils/helper'
  import Swal from 'sweetalert2'
  export default {
    name: 'Soportes',
    setup () {
      const toast = useToast()
      const route = useRoute()
      const contratosStore = useContratosStore()
      const soporte = ref({
        nombre: '',
        nombre_adjunto: '',
        url: ''
      })
      const file = ref()
      const displayModal = ref(false)
      const leerArchivo = async () => {
        const archivo = file.value.files[0]
        soporte.value.nombre_adjunto = archivo.name
        soporte.value.url = await helper.base64String(archivo)
      }
      const guardarArchivo = () => {
        for (const [key, value] of Object.entries(soporte.value)) {
          if (!value) return toast.add({ severity: 'error', summary: 'Error', detail: `Debe ingresar todos los campos, faltante: ${key}`, life: 5000 })
        }
        const info = {
          Url: soporte.value.url,
          Nombre: soporte.value.nombre
        }
        contratosStore.guardarSoporteContrato(route.params.id, [info]).then((data) => {
          console.log('la data-->', data)
          Swal.fire({
            title: 'Guardado',
            text: 'Soporte agregado con éxito',
            icon: 'success'
          }).then(() => {
            cerrarModal()
          })
        })
      }
      const cerrarModal = () => {
        soporte.value = {
          nombre: '',
          nombre_adjunto: '',
          url: ''
        }
        displayModal.value = false
        file.value = ''
      }
      const eliminar = (soporte) => {
        contratosStore.soportes = contratosStore.soportes.filter(a => a !== soporte)
      }
      const eliminarArchivo = () => {
        soporte.value.nombre_adjunto = ''
        soporte.value.url = ''
      }
      const descargarPdf = (ruta) => {
        contratosStore.descargarPdf(ruta)
      }
      return {
        displayModal,
        soporte,
        file,
        leerArchivo,
        guardarArchivo,
        cerrarModal,
        contratosStore,
        eliminar,
        eliminarArchivo,
        descargarPdf,
        Swal,
        route
      }
    }
  }
</script>
